import { TextField, Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar } from 'components';
import { useSigningAuthority } from './useSigningAuthority';

export function SigningAuthority() {
	const { data, errors, members, goBack, submit, t, validate } = useSigningAuthority();
	return (
		<ProgressBar page="signing-authority">
			<Typography TagName="h3" className="mb-4">
				{t('signing_authority_main_title')}
			</Typography>
			<Typography TagName="p" className="mb-4">
				{t('signing_authority_main_text')}
			</Typography>
			<Typography TagName="p" className="mb-4">
				{t('signing_authority')} {data && <b>{data.signingAuthority}</b>}
			</Typography>
			<form className="row mb-4">
				{Array.isArray(members) &&
					members.map((row: any, i: number) => (
						<div key={i} className="col-6 p-3">
							<div className="bg-light">
								<div className="p-4 card-input">
									<Typography TagName="h6" className="mb-1">
										{row.name}
									</Typography>
									<p>{row.roles}</p>
									<TextField
										error={errors[row.ssn]}
										label={t('email')}
										message={t(errors[row.ssn])}
										name={row.ssn}
										onChange={validate}
									/>
								</div>
							</div>
						</div>
					))}
			</form>
			<Footer handleNext={submit} handlePrev={goBack} isDisabled={false} next={t('continue')} prev={t('back')} />
		</ProgressBar>
	);
}
